import styled from 'styled-components'
import { Font12 } from 'components/Typography'

export const LicensingDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const LicensingDescriptionTitle = styled.div`
  font-weight: 900;
  ${Font12};
`

export const LicensingDescriptionLabel = styled.div`
  font-weight: normal;
  ${Font12};
`
